import Image from 'next/image';
import Link from 'next/link';
import globalData from '@/preBuildScripts/data.json';

export default function TopHeader() {
  return (
    <div className="top-header">
      {globalData.notification_header.is_active && (
        <div className="text-center">
          <div
            style={{
              background: globalData.notification_header.background_color,
              color: globalData.notification_header.text_color,
              padding: '4px',
            }}
          >
            {globalData.notification_header.text}
          </div>
        </div>
      )}
      {globalData.top_header.is_active &&
        globalData.top_header.desktop.path && (
          <div>
            <Link href={globalData.top_header.url || '#'} target="_blank">
              <Image
                className="sm:block hidden"
                src={globalData.top_header.desktop.path}
                width={1921}
                height={60}
              />
              <Image
                className="sm:hidden w-full"
                src={globalData.top_header.mobile.path}
                width={578}
                height={30}
              />
            </Link>
          </div>
        )}
      <div className="bg-orange text-white text-center">
        <div>
          به علت مشکل پیش آمده، لطفا برای ارتباط با کارشناسان با شماره زیر در
          تماس باشید
        </div>
        <a href="tel:02191003520">021-91003520</a>
      </div>
    </div>
  );
}
// check page category to show top header ***********
